import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints, ID } from '@rossum/api-client';
import { QueuePatchPayload } from '@rossum/api-client/queues';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { QUERY_KEY_QUEUE } from './useQueue';

const PATCH_QUEUE_MUTATION_KEY = 'patch-queue';

export const usePatchQueue = ({
  silent = false,
}: { silent?: boolean } = {}) => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationKey: [PATCH_QUEUE_MUTATION_KEY],
    mutationFn: ({
      queueId,
      payload,
    }: {
      queueId: ID;
      payload: QueuePatchPayload;
    }) => api.request(endpoints.queues.patch(queueId, payload)),
    onMutate: ({ payload }) => {
      // optimistic update
      queryClient.setQueryData([QUERY_KEY_QUEUE, payload.id], payload);
    },
    onError: () => {
      if (silent) return;
      notify.error({
        title: intl.formatMessage({
          id: 'containers.message.queueError',
        }),
      });
    },
    onSuccess: result => {
      queryClient.invalidateQueries([QUERY_KEY_QUEUE, result.id]);
      if (silent) return;
      notify.default({
        title: intl.formatMessage({
          id: 'containers.message.queueUpdated',
        }),
      });
    },
  });
};
